import { render, staticRenderFns } from "./TsBreadcrumb.vue?vue&type=template&id=5c273486&"
import script from "./TsBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./TsBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports